<script setup lang="ts">
function showAccordion(id: string) {
    const acc = document.getElementById(id)
    if (acc) {
        if (acc.classList.contains('accordion-visible')) {
            acc.classList.remove('accordion-visible')
            acc.classList.add('accordion-hidden')
            return
        }
        acc.classList.remove('accordion-hidden')
        acc.classList.add('accordion-visible')
    }
}
</script>

<template>
    <footer
        id="footer"
        class="bg-[#f1f1f1]"
    >
        <div class="mx-auto max-w-screen-xl">
            <div class="grid grid-cols-1 gap-4 px-4 pb-4 pt-[56px] lg:grid-cols-4 lg:px-12">
                <div class="lg:col-span-2">
                    <h5
                        class="mb-4 flex cursor-pointer justify-between font-semibold text-[#323232] lg:cursor-auto"
                        @click="showAccordion('acc-clients')"
                    >
                        <span> Strefa Klienta </span>
                        <span class="lg:hidden">></span>
                    </h5>
                    <div
                        id="acc-clients"
                        class="accordion-transition accordion-hidden grid grid-cols-1 gap-4 font-medium lg:grid-cols-2"
                    >
                        <ul class="flex flex-col gap-4 pl-3 text-[13px] text-[#505050] lg:mb-4 lg:pl-0">
                            <li><a href="https://www.plus.pl/uslugi">Usługi</a></li>
                            <li><a href="https://doladuj.plus.pl/">Doładuj telefon</a></li>
                            <li><a href="https://www.plus.pl/rejestracja">Rejestruj kartę</a></li>
                            <li><a href="https://www.plus.pl/uslugi/aplikacja-iplus">Aplikacja iPlus</a></li>
                            <li>
                                <a href="https://www.plus.pl/dane-osobowe"
                                    >Informacja o przetwarzaniu danych osobowych</a
                                >
                            </li>
                        </ul>
                        <ul class="flex flex-col gap-4 pl-3 text-[13px] text-[#505050] lg:pl-0">
                            <li><a href="https://www.plus.pl/zgody-marketingowe">Zgody marketingowe</a></li>
                            <li><a href="https://www.plus.pl/status-zamowienia">Status zamówienia</a></li>
                            <li><a href="https://www.plus.pl/sprawdz-status-mnp">Status przeniesienia numeru</a></li>
                            <li>
                                <a href="https://www.plus.pl/formularze/formularz-imei"
                                    >Weryfikacja sprzętu ratalnego</a
                                >
                            </li>
                            <li>
                                <a href="https://www.plus.pl/aktualnosci-i-komunikaty/akt-o-uslugach-cyfrowych"
                                    >Akt o Usługach Cyfrowych / Digital Services Act</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>

                <div>
                    <h5
                        class="mb-4 flex cursor-pointer justify-between font-semibold text-[#323232] lg:cursor-auto"
                        @click="showAccordion('acc-help')"
                    >
                        <span> Pomoc </span>
                        <span class="lg:hidden">></span>
                    </h5>
                    <div
                        id="acc-help"
                        class="accordion-transition accordion-hidden grid grid-cols-1 font-medium lg:grid-cols-2"
                    >
                        <ul class="mb-4 flex flex-col gap-4 pl-3 text-[13px] text-[#505050] lg:pl-0">
                            <li><a href="https://bok.plus.pl/">Porady - FAQ</a></li>
                            <li><a href="https://ustaw.plus.pl/konfiguruj-telefon">Skonfiguruj telefon</a></li>
                            <li><a href="https://www.plus.pl/5g">5G w Plusie</a></li>
                            <li><a href="https://www.plus.pl/znajdz-salon">Punkty sprzedaży</a></li>
                            <li><a href="https://www.plus.pl/mapa-zasiegu">Mapa zasięgu internetu</a></li>
                            <li><a href="https://www.plus.pl/regulaminy-i-cenniki">Regulaminy i cenniki</a></li>
                            <li><a href="https://www.plus.pl/biuro-numerow">Biuro numerów</a></li>
                            <li><a href="https://www.plus.pl/uslugi/uslugi-premium">Numery Premium rate</a></li>
                            <li><a href="https://www.plus.pl/internet-pobierz">Internet LTE - Pliki do pobrania</a></li>
                            <li><a href="https://www.plus.pl/speedtest">Sprawdź prędkość internetu</a></li>
                            <li><a href="https://www.plus.pl/zwroty">Darmowe zwroty</a></li>
                        </ul>
                    </div>
                </div>
                <div>
                    <h5
                        class="mb-4 flex cursor-pointer justify-between font-semibold text-[#323232] lg:cursor-auto"
                        @click="showAccordion('acc-others')"
                    >
                        <span> Pozostałe usługi </span>
                        <span class="lg:hidden">></span>
                    </h5>
                    <div
                        id="acc-others"
                        class="accordion-transition accordion-hidden grid grid-cols-1 font-medium lg:grid-cols-2"
                    >
                        <ul class="mb-4 flex flex-col gap-4 pl-3 text-[13px] text-[#505050] lg:pl-0">
                            <li><a href="https://bok.plus.pl/forum/">Forum Plusa</a></li>
                            <li>
                                <a href="https://sklep.polsatbox.pl/telewizja-internetowa-ott">Telewizja internetowa</a>
                            </li>
                            <li>
                                <a href="https://sklep.polsatbox.pl/IPTV-telewizja-kablowa">Telewizja kablowa IPTV</a>
                            </li>
                            <li>
                                <a href="https://sklep.polsatbox.pl/telewizja-satelitarna">Telewizja satelitarna</a>
                            </li>
                            <li><a href="https://www.plus.pl/uslugi/polsatboxgo">Polsat Box Go</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-1 px-3 pb-3 md:grid-cols-2">
                <div>
                    <ul class="flex flex-wrap justify-center text-sm font-bold leading-none md:justify-end">
                        <li class="my-2 border-r border-black px-2">
                            <a href="https://www.plus.pl/news/ospolce">O firmie</a>
                        </li>
                        <li class="my-2 border-r border-black px-2">
                            <a href="https://www.plus.pl/kontakt">Kontakt</a>
                        </li>
                        <li class="my-2 border-r border-black px-2">
                            <a href="https://www.plus.pl/blog/biuro-prasowe">Biuro prasowe</a>
                        </li>
                        <li class="my-2 border-r border-black px-2">
                            <a href="https://www.plus.pl/aktualnosci-i-komunikaty">Komunikaty</a>
                        </li>
                        <li class="my-2 border-r border-black px-2">
                            <a href="https://grupapolsatplus.pl/pl/praca">Grupa Polsat Plus</a>
                        </li>
                        <li class="my-2 border-r border-black px-2">
                            <a href="https://www.plus.pl/news/kariera">Kariera</a>
                        </li>
                        <li class="my-2 border-r border-black px-2">
                            <a href="https://www.plus.pl/polityka-prywatnosci">Polityka prywatności</a>
                        </li>
                        <li class="my-2 px-2">
                            <a
                                id="ot-sdk-btn"
                                href="#"
                                class="ot-sdk-show-settings"
                                >Ustawienia</a
                            >
                        </li>
                    </ul>
                </div>

                <div
                    id="copyright"
                    class="text-center text-xs font-semibold text-[#adadad] md:order-first md:text-left"
                >
                    <p>
                        © 2024 Polkomtel Sp. z o.o. Wszystkie prawa zastrzeżone LTE™ to zastrzeżony znak towarowy
                        należący do ETSI.
                    </p>
                    <p>© 2024 Disney i podmioty powiązane.</p>
                </div>
            </div>
        </div>

        <div class="bg-[#00283d]">
            <div
                class="mx-auto grid max-w-screen-xl grid-cols-1 grid-rows-2 font-bold text-white md:grid-cols-2 md:grid-rows-1 lg:flex lg:items-center lg:justify-between"
            >
                <div class="flex justify-center gap-4 border-b border-white px-3 py-2 md:border-none">
                    <a
                        href="https://www.plus.pl/znajdz-salon"
                        class="flex items-center gap-2"
                    >
                        <img
                            src="https://api.plus.pl/file/files/file/images_lp/plus/sg/footer/punkt_sprzedazy.webp"
                            alt="Punkty sprzedaży"
                        />
                        <span>Punkty sprzedaży</span>
                    </a>
                    <a
                        href="https://www.plus.pl/udogodnienia"
                        class="hidden items-center gap-2 lg:flex"
                    >
                        <img
                            src="https://api.plus.pl/jcr/files/file/adp/files/images_lp/plus/sg/footer/special.webp"
                            alt="Udogodnienia dla osób z niepełnosprawnościami"
                        />
                        <span>Udogodnienia dla osób z niepełnosprawnościami</span>
                    </a>
                </div>
                <div class="flex items-center justify-center gap-6 px-3 py-2 md:order-first lg:justify-start">
                    <p class="hidden lg:inline-block">Śledź nas:</p>
                    <a href="https://www.facebook.com/plus">
                        <img
                            src="https://api.plus.pl/file/files/file/others/social_icons/plus/facebook-icon.svg"
                            alt="facebook icon"
                            width="25"
                            height="25"
                        />
                    </a>
                    <a href="https://www.youtube.com/user/PLUSPL">
                        <img
                            src="https://api.plus.pl/file/files/file/others/social_icons/plus/yt-vector.svg"
                            alt="youtube icon"
                            width="25"
                            height="25"
                        />
                    </a>
                    <a href="https://www.instagram.com/plus_polska/">
                        <img
                            src="https://api.plus.pl/file/files/file/others/social_icons/plus/instagram-vector.svg"
                            alt="instagram icon"
                            width="25"
                            height="25"
                        />
                    </a>
                    <a href="https://twitter.com/Plus_Polska?lang=pl">
                        <img
                            src="https://api.plus.pl/file/files/file/others/social_icons/plus/x-vector.svg"
                            alt="twitter / x icon"
                            width="25"
                            height="25"
                        />
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<style lang="css" scoped>
@keyframes accordionShow {
    from {
        max-height: 0;
        opacity: 0;
    }

    to {
        max-height: 1500px;
        opacity: 1;
    }
}
@keyframes accordionHide {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-100%);
    }
}

#ot-sdk-btn.ot-sdk-show-settings {
    color: inherit;
    border: unset;
    font-size: inherit;
    line-height: inherit;
    padding: unset;
    background-color: unset;
}

@media screen and (max-width: 1024px) {
    .accordion-transition {
        transition:
            max-height 1s ease-in-out,
            opacity 0.5s linear 0.3s,
            padding 1s,
            margin 1s;
        overflow: hidden;
    }
    .accordion-visible {
        max-height: 1500px;
        opacity: 1;
    }
    .accordion-hidden {
        max-height: 0;
        opacity: 0;
    }
}
</style>
